/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_FeaturesInputs */

const en_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const ar_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المميزات`)
};

const bn_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিচার`)
};

const de_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

const es_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características`)
};

const fr_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractéristiques`)
};

const pt_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const zh_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特点`)
};

const tr_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellikler`)
};

const ru_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Особенности`)
};

const pl_wd_features = /** @type {(inputs: Wd_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Wd_FeaturesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_features = /** @type {((inputs?: Wd_FeaturesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_FeaturesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_features(inputs)
	if (locale === "bn") return bn_wd_features(inputs)
	if (locale === "de") return de_wd_features(inputs)
	if (locale === "es") return es_wd_features(inputs)
	if (locale === "fr") return fr_wd_features(inputs)
	if (locale === "pt") return pt_wd_features(inputs)
	if (locale === "zh") return zh_wd_features(inputs)
	if (locale === "tr") return tr_wd_features(inputs)
	if (locale === "ru") return ru_wd_features(inputs)
	if (locale === "pl") return pl_wd_features(inputs)
	return en_wd_features(inputs)
});